export default {
  headers: [
    ['satellite-tracking/report.date_time', 'dateTime'],
    ['satellite-tracking/report.voltage', 'power']
  ]
}
